'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _themeCart = require('@shopify/theme-cart');

var cart = _interopRequireWildcard(_themeCart);

var _cssClasses = require('./cssClasses');

var _cssClasses2 = _interopRequireDefault(_cssClasses);

var _utils = require('./utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DOM selectors.
 */
/**
 * Helper: Ajax cart
 * ------------------------------------------------------------------------------
 * An event based interface to support in communicating across components
 * that sends and retrieves responses from Ajax cart interactions.
 *
 * @namespace ajaxCart
 */
var selectors = {
  container: '[js-ajax-cart="container"]',
  addToCart: '[js-ajax-cart="addToCart"]',
  clearCart: '[js-ajax-cart="clearCart"]',
  remove: '[js-ajax-cart="remove"]',
  lineItem: '[js-ajax-cart="lineItem"]',
  form: '[js-ajax-cart="form"]',
  cartCounter: '[js-ajax-cart="cartCounter"]'
};

/**
 * Export a new AjaxCart instance
 * @param {object} config - Settings to apply across all Ajax calls to the cart.
 */

exports.default = function (config) {

  /**
   * Node selectors.
   */
  var nodeSelectors = {
    addToCart: [].concat((0, _toConsumableArray3.default)(document.querySelectorAll(selectors.addToCart))),
    cartCounter: [].concat((0, _toConsumableArray3.default)(document.querySelectorAll(selectors.cartCounter))),
    clearCart: [].concat((0, _toConsumableArray3.default)(document.querySelectorAll(selectors.clearCart))),
    container: [].concat((0, _toConsumableArray3.default)(document.querySelectorAll(selectors.container)))
  };

  /**
  * Initialise component.
  */
  function init() {
    setListeners();
    setAddToCartEvents();
    setClearCartEvents();
    setRemoveEvents();
  }

  /**
   * Set listeners.
   */
  function setListeners() {

    /**
     * Reinitialise Ajax cart on call.
     */
    Frame.EventBus.listen(['AjaxCart:init', 'AjaxCart:reinit'], function () {
      setRemoveEvents();
    });

    /**
     * React to any item changes in the cart.
     */
    Frame.EventBus.listen(['AjaxCart:itemAdded', 'AjaxCart:itemRemoved', 'AjaxCart:itemUpdated', 'AjaxCart:cartCleared'], function (response) {
      updateCounter();
      if (response.item_count <= 0) {
        Frame.EventBus.emit('AjaxCart:cartEmpty', response);
      }
    });

    /**
     * Global helper function to add items to cart and trigger
     * responses and linked interactions.
     */
    Frame.EventBus.listen('AjaxCart:addItem', function (_ref) {
      var id = _ref.id,
          options = _ref.options;

      cart.addItem(id, options).then(function (response) {
        return Frame.EventBus.emit('AjaxCart:itemAdded', response);
      }).catch(function (error) {
        return error;
      });
    });

    Frame.EventBus.listen('AjaxCart:removeItem', function (key) {
      cart.removeItem(key).then(function (response) {
        return Frame.EventBus.emit('AjaxCart:itemRemoved', response);
      }).catch(function (error) {
        return error;
      });
    });
  }

  /**
  * Set click events on buttons to post form data.
  */
  function setAddToCartEvents() {
    nodeSelectors.addToCart.forEach(function (element) {
      (0, _utils.on)('click', element, function (event) {
        return handleAddToCart(event);
      });
      (0, _utils.on)('keydown', element, function (event) {
        return handleAddToCart(event);
      });
    });
  }

  /**
   * Handle add to cart event and set loading state.
   * @param {object} event - Click and key down event.
   */
  function handleAddToCart(event) {
    if (isKeyDownEvent(event) && !isKeyPressIsEnter(event)) {
      return;
    }

    event.preventDefault();
    var target = event.currentTarget;

    setLoadingState(target);

    _axios2.default.post('/cart/add.js', (0, _utils.serialize)(target.closest('form'))).then(function (response) {
      Frame.EventBus.emit('AjaxCart:itemAdded', response);
      setDefaultState(target);
      executeCallback();
      return response;
    }).catch(function (error) {
      setDefaultState();
      return error;
    });
  }

  /**
  * Set remove item events.
  */
  function setRemoveEvents() {
    [].concat((0, _toConsumableArray3.default)(document.querySelectorAll(selectors.remove))).forEach(function (element) {
      (0, _utils.on)('click', element, function (event) {
        return handleRemoveEvent(event);
      });
      (0, _utils.on)('keydown', element, function (event) {
        return handleRemoveEvent(event);
      });
    });
  }

  /**
   * Handle remove event.
   * @param {Event} event - Click/keydown event object.
   */
  function handleRemoveEvent(event) {
    event.preventDefault();

    if (isKeyDownEvent(event) && !isKeyPressIsEnter(event)) {
      return;
    }

    Frame.EventBus.emit('AjaxCart:removingItem', event.currentTarget.closest(selectors.lineItem));
    event.preventDefault();

    cart.removeItem(event.currentTarget.dataset.key).then(function (response) {
      Frame.EventBus.emit('AjaxCart:itemRemoved', response);
      return response;
    }).catch(function (error) {
      return error;
    });
  }

  /**
   * Check if key down event.
   * @param {Event} event - Keydown event object.
   */
  function isKeyDownEvent(event) {
    return event.type === 'keydown';
  }

  /**
   * Check if the return key is pressed.
   * @param {Event} event - Key code event.
   */
  function isKeyPressIsEnter(event) {
    return event.which === 13;
  }

  /**
   * Set clear cart events if enabled.
   */
  function setClearCartEvents() {
    if (!nodeSelectors.clearCart) {
      return;
    }

    nodeSelectors.clearCart.forEach(function (element) {
      (0, _utils.on)('click', element, function (event) {
        return clearItems(event);
      });
    });
  }

  /**
   * Handle clear cart events.
   * @param {Event} event - Click/keydown event object.
   */
  function clearItems(event) {
    event.preventDefault();

    cart.clearItems().then(function (response) {
      Frame.EventBus.emit('AjaxCart:cartCleared', response);
      return response;
    }).catch(function (error) {
      return error;
    });
  }

  /**
   * Update cart counter.
   */
  function updateCounter() {
    _axios2.default.get('/cart.js').then(function (response) {
      nodeSelectors.cartCounter.forEach(function (item) {
        renderCartCounter(response.data, item);
      });
      return response.data.item_count;
    }).catch(function (error) {
      return error;
    });
  }

  /**
   * Render cart counter.
   * @param {Object} response - Cart.json data.
   */
  function renderCartCounter(response, item) {
    var giftWrap = giftCount(response);
    var count = response.item_count - giftWrap;
    item.classList.remove(_cssClasses2.default.hidden);
    item.innerText = count;

    if (count <= 0) {
      item.classList.add(_cssClasses2.default.hidden);
    }
  }

  /**
   * Check if there is a gift wrapping product in the cart
   */
  function giftCount(response) {
    var count = 0;
    response.items.forEach(function (item) {
      if (item.id === window.theme.giftWrap.id) {
        count = 1;
      }
    });
    return count;
  }

  /**
   * Set loading state.
   * @param {object} target clicked add to cart button in DOM.
   */
  function setLoadingState(target) {
    [].concat((0, _toConsumableArray3.default)(nodeSelectors.addToCart)).forEach(function (element) {
      if (target === element) {
        element.innerText = theme.strings.addingToCart;
      }
    });
  }

  /**
  * Reset the loading states back to default.
  * @param {object} target clicked add to cart button in DOM.
  */
  function setDefaultState(target) {
    [].concat((0, _toConsumableArray3.default)(nodeSelectors.addToCart)).forEach(function (element) {
      if (target === element) {
        element.innerText = theme.strings.addToCart;
      }
    });
  }

  /**
   * Execute callback function defined in constructor.
   */
  function executeCallback() {
    return typeof config.callback === 'function' ? config.callback() : false;
  }

  /**
   * Public interface.
   */
  return Object.freeze({
    init: init
  });
};